// extracted by mini-css-extract-plugin
export default {"wrapper":"HomePage_wrapper__-eJ2Y","hello":"HomePage_hello__d98xW","jobs":"HomePage_jobs__ep2cX","name":"HomePage_name__2REWt"};